import * as React from "react";
import { DetailItem } from "main/javascripts/components/spot/DetailItem";
import { DetailItemText } from "main/javascripts/components/spot/DetailItemText";

export interface IProps {
  checkout: string | null;
}

export const HotelCheckout: React.FC<IProps> = (
  props: IProps
): React.ReactElement | null => {
  const { checkout } = props;
  if (!checkout || checkout === "") {
    return null;
  }
  return (
    <DetailItem title="チェックアウト">
      <DetailItemText>チェックアウト時刻 : {checkout}</DetailItemText>
    </DetailItem>
  );
};
